<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
    </qx-card>
  </section>
</template>
<script>
import {
  getVehicleStandingBookInfo, // 获取详情
} from 'api/car';
import {
  getFileUrl,
} from 'api';
export default {
  components: {
  },
  data () {
    return {
      title: '查看证照登记',
      loading: false,
      detailData: {
        base: {
          label: '车辆信息',
          tableData: {
            title: [
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'orgName',
                label: '车辆归属',
              },
              {
                prop: 'licenceTypeName',
                label: '车辆类型',
              },
              {
                prop: 'vehicleOwnerShipName',
                label: '车辆性质',
              },
              {
                prop: 'brandModel',
                label: '品牌名称',
              },
              {
                prop: 'vehicleOriginName',
                label: '配置',
              },
              {
                prop: 'vehicleState',
                label: '使用状态',
              },
              {
                prop: 'drivingLicenseDate',
                label: '行驶证注册日期',
              },
            ],
            data: {},
            approveData: {},
          },
        },
        info: {
          label: 'GPS信息',
          tableData: {
            title: [
              {
                prop: 'serviceName',
                label: '服务商',
              },
              {
                prop: 'equipmentNumber',
                label: '设备号',
              },
              {
                prop: 'serviveLoseDate',
                label: '服务失效时间',
              },
              {
                prop: 'suitTypeName',
                label: '套装类型',
              },
              {
                prop: 'suitFee',
                label: 'GPS套装费用',
                unit: '元',
              },
            ],
            data: {},
            approveData: {},
          },
        },
      },
    };
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/maintain/gps/detail') {
        return;
      }
      this.loading = true;
      const detailRes = await getVehicleStandingBookInfo({
        id: this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        detailRes.suitFee = detailRes.suitFee / 100;
        detailRes.drivingLicenseDate = this.formatDate(detailRes.drivingLicenseDate);
        this.detailData.info.tableData.title.splice(5);
        let equoipmentInfo = [];
        if (detailRes.suitType === 1) {
          equoipmentInfo = [
            { prop: 'gpsEquoipmentBrand', label: '定位设备品牌' },
            { prop: 'gpsEquoipmentModel', label: '定位设备型号' },
            { prop: 'gpsEquoipmentNumber', label: '定位设备号' },
          ];
        } else if (detailRes.suitType === 2) {
          equoipmentInfo = [
            { prop: 'oilWearEquoipmentBrand', label: '油耗设备品牌' },
            { prop: 'oilWearEquoipmentModel', label: '油耗设备型号' },
            { prop: 'oilWearEquoipmentNumber', label: '油耗设备号' },
          ];
        } else if (detailRes.suitType === 3) {
          equoipmentInfo = [
            { prop: 'gpsEquoipmentBrand', label: '定位设备品牌' },
            { prop: 'gpsEquoipmentModel', label: '定位设备型号' },
            { prop: 'gpsEquoipmentNumber', label: '定位设备号' },
            { prop: 'oilWearEquoipmentBrand', label: '油耗设备品牌' },
            { prop: 'oilWearEquoipmentModel', label: '油耗设备型号' },
            { prop: 'oilWearEquoipmentNumber', label: '油耗设备号' },
          ];
        }

        this.detailData.info.tableData.title.push(...equoipmentInfo);

        // 重置一下展示的字段长度，防止来回切换 tab 的时候图片字段不断增多
        // 获取图片 id 然后去请求另外一个接口获取图片url地址
        if (detailRes.picList && detailRes.picList.length) {
          let flowIds = [];
          for (let i = 0; i < detailRes.picList.length; i++) {
            flowIds.push(detailRes.picList[i].fileId);
            this.detailData.info.tableData.title.push({
              prop: 'pic' + i,
              label: '证件图片' + (i + 1),
              type: 'img',
            });
          }

          const imgRes = await getFileUrl({
            flowIds: flowIds.join(),
          });

          for (let i = 0; i < detailRes.picList.length; i++) {
            imgRes.items.forEach((item) => {
              if (item.flowId === detailRes.picList[i].fileId) {
                detailRes['pic' + i] = item.fullPath;
              }
            });
          }
        } else {
          this.detailData.info.tableData.title.push({
            prop: 'pic',
            label: '证件图片',
            type: 'img',
          });
        }

        // 处理数据
        this.detailData.base.tableData.data = detailRes;
        this.detailData.info.tableData.data = detailRes;
      }
    },
    // async sub (formData) {
    // },
  },
  mounted () {
    this.getData();
  },
};
</script>
<style>
</style>
